import { MenuItem as MenuItemPrimitive } from '@mui/material';
import { Check, Close, NavigateRight } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
import classnames from 'classnames';
import { useContext } from 'react';

import { Loader } from '../../Loader/Loader.component';
import { parseMutationStatus } from '../../utils';
import { menuContext } from '../Menu/Menu.types';

import styles from './MenuItem.module.scss';
import { MenuItemProps } from './MenuItem.types';

export const MenuItem = ({
  className,
  children,
  focus,
  onClick,
  error,
  hasSubMenu,
  keepOpenOnClick,
  selected,
  mutationStatus,
  disabled,
  ...props
}: MenuItemProps) => {
  const menu = useContext(menuContext);

  const { isPending, isSuccess, isError } = parseMutationStatus(mutationStatus);

  return (
    <MenuItemPrimitive
      disableRipple
      tabIndex={0}
      focusVisibleClassName={styles.focus}
      className={classnames(styles.container, className, {
        [styles.disabled]: disabled,
        [styles.focus]: focus || selected,
        [styles.error]: error,
        [styles.mutationPending]: isPending,
        [styles.mutationSuccess]: isSuccess,
        [styles.mutationError]: isError,
      })}
      onClick={event => {
        if (disabled) return;
        onClick?.(event);
        if (!hasSubMenu && !keepOpenOnClick) {
          menu?.close();
        }
      }}
      disabled={disabled || isPending || isSuccess || isError}
      {...props}
    >
      {isPending && (
        <Loader size="small" variant="secondary" className={styles.mutationIndicator} />
      )}
      {isSuccess && <Check className={styles.mutationIndicator} />}
      {isError && <Close className={styles.mutationIndicator} />}
      <span className={styles.children}>{children}</span>
      {hasSubMenu ? <NavigateRight /> : selected ? <Check /> : undefined}
    </MenuItemPrimitive>
  );
};
